var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "section",
      { staticClass: "py-12", attrs: { id: "heading" } },
      [_c("header-nav")],
      1
    ),
    _vm._v(" "),
    _c(
      "section",
      { staticClass: "py-12" },
      [
        _vm.errorText
          ? _c("div", { staticClass: "max-w-sm mx-auto px-6 mb-6" }, [
              _c(
                "div",
                {
                  staticClass:
                    "bg-red-light w-full shadow border border-red-light text-white px-4 py-3 rounded relative"
                },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "font-semibold",
                    domProps: { textContent: _vm._s(_vm.errorText) }
                  })
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.loadingAppointments ||
        _vm.loadingInvitations ||
        _vm.loadingEmergencies ||
        _vm.loadingPartnerAppointments
          ? _c("patient-loading")
          : _vm._e(),
        _vm._v(" "),
        !_vm.loadingInvitations &&
        Object.keys(_vm.invitations).length &&
        _vm.patient
          ? _c(
              "div",
              { staticClass: "max-w-sm mx-auto px-6" },
              [
                _c("div", {
                  staticClass:
                    "uppercase tracking-wide text-grey-darker text-sm font-semibold mb-6",
                  domProps: {
                    textContent: _vm._s(_vm.$t("Invitation_from_dentist"))
                  }
                }),
                _vm._v(" "),
                _vm._l(_vm.sortedInvitations, function(invitation) {
                  return _c("invitation-list-item", {
                    key: invitation.id,
                    attrs: { invitation: invitation }
                  })
                })
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.loadingEmergencies &&
        Object.keys(_vm.emergencies).length &&
        _vm.patient
          ? _c(
              "div",
              { staticClass: "max-w-sm mx-auto px-6" },
              [
                _c("div", {
                  staticClass:
                    "uppercase tracking-wide text-grey-darker text-sm font-semibold mb-6",
                  domProps: { textContent: _vm._s(_vm.$t("Pending")) }
                }),
                _vm._v(" "),
                _vm._l(_vm.sortedEmergencies, function(emergency) {
                  return _c("emergency-list-item", {
                    key: emergency.id,
                    attrs: { emergency: emergency },
                    on: { deleted: _vm.fetchEmergencies }
                  })
                })
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.loadingAppointments &&
        (Object.keys(_vm.appointments).length ||
          Object.keys(_vm.partnerAppointments).length) &&
        _vm.patient
          ? _c(
              "div",
              { staticClass: "max-w-sm mx-auto px-6" },
              [
                _c("div", {
                  staticClass:
                    "uppercase tracking-wide text-grey-darker text-sm font-semibold mb-6",
                  domProps: {
                    textContent: _vm._s(_vm.$t("Your_confirmed_appointments"))
                  }
                }),
                _vm._v(" "),
                _vm._l(_vm.sortedAppointments, function(appointment) {
                  return _c("appointment-list-item", {
                    key: appointment.id,
                    attrs: { appointment: appointment }
                  })
                }),
                _vm._v(" "),
                _vm._l(_vm.sortedPartnerAppointments, function(appointment) {
                  return _c("partner-appointment-list-item", {
                    key: appointment.id,
                    attrs: { appointment: appointment }
                  })
                })
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "max-w-sm mx-auto px-6" },
          [
            _c(
              "router-link",
              {
                staticClass:
                  "inline-block w-full px-4 py-3 rounded bg-blue hover:bg-blue-dark text-sm text-white uppercase tracking-wide font-semibold text-center",
                attrs: { to: { name: "search" } }
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("Find_an_appointment")) +
                    "\n            "
                )
              ]
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon mr-1 text-lg" }, [
      _c("i", { staticClass: "mdi mdi-alert-circle-outline" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8dc7cce2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8dc7cce2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 606
// module chunks = 1